const IsJsonString = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

const getItemFromCookies = key => {
  const name = key + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      const a = c.substring(name.length, c.length);
      if (IsJsonString(a)) {
        return JSON.parse(a);
      }
      return a;
    }
  }
  return '';
};

export const getItemFromPersistentStore = (key, defaultValue) => {
  let value = localStorage.getItem(key);
  if (!value) {
    let dataFromCookie = '';
    try {
      dataFromCookie = getItemFromCookies(key);
    } catch (err) {}
    return dataFromCookie || defaultValue;
  }
  try {
    value = JSON.parse(value);
  } catch (error) {}
  return value;
};

export const getUserDetails = (key, defaultValue) => {
  let userData = getItemFromPersistentStore(key, null);
  if (userData === null) {
    const key = 'uifReadable';
    const dataFromCookie = getItemFromCookies(key);
    const decodedData = atob(dataFromCookie);
    try {
      userData = JSON.parse(decodedData);
    } catch (e) {}
  }
  return userData || defaultValue;
};

export const clearPersistentStore = () => {
  localStorage.clear();
};

export const setItemInPersistentStore = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};
